import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import {
  type SetMapScreenViewportAreaParam,
  type SetMapScreenViewportCenterParam,
  type SetMapZoomParam,
} from './map-operation-api/index.js';

/**
 * 启动打车插件配置选项
 */
export type FabricMapStartOptions = {
  /**
   * 全屏webview还是半屏webview
   * Note: 半屏webview不支持自定义, 大小有native 写死.
   */
  screen: 'full' | 'half';
  /**
   * 动画方向从下往上top, 动画方向从右往左left, 从左往右只支持全屏, 半屏幕支持上往下, 左往右
   */
  direction?: 'top' | 'left';
  /**
   * 启动打车插件配置
   */
  config: {
    /**
     * 启动页H5地址 https://
     */
    entryPage: string;
    /**
     * 缩放级别（默认3-19，有室内地图时为3-20）
     * +/-/0, 传递0 不做缩放动作, 但是可以通过返回值回去当下是否可以放大/缩小
     * 也可以单独调用`setMap`.`setMapZoom` API
     * @default 16
     */
    zoomLevel?: SetMapZoomParam['zoomLevel'];
    /**
     * 设置地图居中展示区域的中心点位置的API输入参数, 其他地图移动都会依据这个显示位置的缩放, 移动, 聚拢.
     * 也可以单独调用`setMap`.`setMapScreenViewportCenter` API
     */
    mapScreenViewportCenter?: SetMapScreenViewportCenterParam;
    /**
     * 设置Native地图中划线起点/终点落在的区域,Native 需要根据这个区域做适当的缩放计算.
     * 也可以单独调用`setMap`.`setMapScreenViewportArea` API
     */
    mapScreenViewportArea?: SetMapScreenViewportAreaParam;
  };
};

export type FabricMapStartApi = (
  options: FabricMapStartOptions
) => Promise<boolean>;

/**
 * 启动打车插件.
 */
export const startMap: FabricMapStartApi = (
  options: FabricMapStartOptions
): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<'fabric_map.startMap', FabricMapStartOptions, boolean>(
      'fabric_map.startMap',
      options,
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
